export default {
  "menu.welcome": "Chào mừng",
  "menu.more-blocks": "Thêm Khối",
  "menu.home": "Trang chủ",
  "menu.admin": "Quản trị",
  "menu.admin.sub-page": "Trang con",
  "menu.login": "Đăng nhập",
  "menu.register": "Đăng ký",
  "menu.register-result": "Kết quả đăng ký",

  "menu.users": "Quản lý người dùng",
  "menu.users.user-list": "Danh sách người dùng",
  "menu.users.top-users-streak": "Top người dùng streak",
  "menu.users.user-detail": "Chi tiết người dùng",
  "menu.food-database": "Dữ liệu thực phẩm",
  "menu.food-database.foods": "Thực phẩm",
  "menu.food-database.foods.food-list": "Danh sách thực phẩm",
  "menu.food-database.foods.create-food": "Tạo thực phẩm mới",
  "menu.food-database.foods.create-packaged-food":
    "Tạo thực phẩm đóng gói (barcode)",
  "menu.food-database.foods.update-food": "Cập nhật thực phẩm",
  "menu.food-database.foods.food-detail": "Chi tiết thực phẩm",
  "menu.food-database.categories": "Danh mục",
  "menu.food-database.categories.category-list": "Danh sách danh mục",
  "menu.food-database.categories.create-category": "Tạo danh mục mới",
  "menu.food-database.categories.update-category": "Cập nhật danh mục",
  "menu.food-database.brands": "Thương hiệu",
  "menu.food-database.brands.brand-list": "Danh sách thương hiệu",
  "menu.food-database.brands.create-brand": "Tạo thương hiệu mới",
  "menu.food-database.brands.update-brand": "Cập nhật thương hiệu",
  "menu.food-database.brands.brand-detail": "Chi tiết thương hiệu",
  "menu.food-database.image-enrichment": "Làm giàu ảnh thực phẩm",
  "menu.food-database.food-tags": "Food Tags",
  "menu.food-database.food-tags.tag-list": "Danh sách tag",
  "menu.food-database.food-tags.create-tag": "Tạo tag",
  "menu.food-database.food-tags.update-tag": "Cập nhật tag",
  "menu.food-database.custom-foods": "Thực phẩm người dùng",
  "menu.food-database.custom-foods.custom-foods-list":
    "Danh sách thực phẩm người dùng",
  "menu.food-contributions": "Quét mã tích điểm",
  "menu.food-contributions.list": "Hàng đợi duyệt",
  "menu.food-contributions.detail": "Chi tiết đóng góp",
  "menu.food-contributions.user-locks": "Khoá người dùng",
  "menu.food-contributions.violation-stats": "Thống kê vi phạm",
  "menu.eatsy-coin": "Eatsy Coin",
  "menu.eatsy-coin.dashboard": "Dashboard",
  "menu.eatsy-coin.wallets": "Ví người dùng",
  "menu.eatsy-coin.ledger": "Sổ cái",
  "menu.eatsy-coin.redemptions": "Đổi Premium",
  "menu.eatsy-coin.config": "Cấu hình",
  "menu.system": "Cài đặt hệ thống",
  "menu.system.countries": "Quốc gia",
  "menu.system.countries.country-list": "Danh sách quốc gia",
  "menu.system.countries.create-country": "Tạo quốc gia mới",
  "menu.system.countries.update-country": "Cập nhật quốc gia",
  "menu.system.countries.country-detail": "Chi tiết quốc gia",
  "menu.system.languages": "Ngôn ngữ",
  "menu.system.languages.language-list": "Danh sách ngôn ngữ",
  "menu.system.languages.create-language": "Tạo ngôn ngữ mới",
  "menu.system.languages.update-language": "Cập nhật ngôn ngữ",
  "menu.system.languages.language-detail": "Chi tiết ngôn ngữ",
  "menu.system.timezones": "Múi giờ",
  "menu.system.timezones.timezone-list": "Danh sách múi giờ",
  "menu.system.timezones.create-timezone": "Tạo múi giờ mới",
  "menu.system.timezones.update-timezone": "Cập nhật múi giờ",
  "menu.system.timezones.timezone-detail": "Chi tiết múi giờ",
  "menu.system.system-config": "Cấu hình hệ thống",
  "menu.exercise-activity": "Tập luyện",
  "menu.exercise-activity.categories": "Danh mục bài tập",
  "menu.exercise-activity.categories.category-list": "Danh sách danh mục",
  "menu.exercise-activity.categories.create-category": "Tạo danh mục",
  "menu.exercise-activity.categories.update-category": "Cập nhật danh mục",
  "menu.exercise-activity.exercises": "Bài tập",
  "menu.exercise-activity.exercises.exercise-list": "Danh sách bài tập",
  "menu.exercise-activity.exercises.create-exercise": "Tạo bài tập",
  "menu.exercise-activity.exercises.update-exercise": "Cập nhật bài tập",
  "menu.exercise-activity.difficulty-levels": "Mức độ khó",
  "menu.exercise-activity.difficulty-levels.difficulty-level-list":
    "Danh sách mức độ",
  "menu.exercise-activity.difficulty-levels.create-difficulty-level":
    "Tạo mức độ",
  "menu.exercise-activity.difficulty-levels.update-difficulty-level":
    "Cập nhật mức độ",
  "menu.water-management": "Quản lý nước",
  "menu.water-management.water-types": "Loại nước",
  "menu.water-management.water-types.water-type-list": "Danh sách loại nước",
  "menu.water-management.water-types.create-water-type": "Tạo loại nước mới",
  "menu.water-management.water-types.update-water-type": "Cập nhật loại nước",
  "menu.recommendations": "Gợi ý thông minh",
  "menu.recommendations.dashboard": "Tổng quan",
  "menu.recommendations.sessions": "Phiên gợi ý",
  "menu.recommendations.session-detail": "Chi tiết phiên",
  "menu.recommendations.allergen-coverage": "Độ phủ Allergen",
  "menu.recommendations.allergen-mappings": "Mapping Allergen",
  "menu.recommendations.time-period-options": "Khung thời gian",
  "menu.recommendations.access-control": "Kiểm soát truy cập",
  "menu.recommendations.algorithm-config": "Cấu hình thuật toán",
  "menu.recommendations.catalog-source-registry": "Nguồn dữ liệu món ăn",
  "menu.recommendations.onboarding-catalogues": "Catalogue onboarding",
  "menu.dish-management": "Quản lý món ăn",
  "menu.dish-management.dishes": "Món ăn",
  "menu.dish-management.dishes.dish-list": "Danh sách món ăn",
  "menu.dish-management.dishes.create-dish": "Tạo món ăn",
  "menu.dish-management.dishes.update-dish": "Cập nhật món ăn",
  "menu.dish-management.dishes.dish-detail": "Chi tiết món ăn",
  "menu.dish-management.custom-dishes": "Món ăn người dùng",
  "menu.dish-management.custom-dishes.custom-dishes-list":
    "Danh sách món ăn người dùng",
  "menu.dish-management.categories": "Danh mục món",
  "menu.dish-management.categories.category-list": "Danh sách danh mục",
  "menu.dish-management.categories.create-category": "Tạo danh mục",
  "menu.dish-management.categories.update-category": "Cập nhật danh mục",
  "menu.dish-management.categories.category-detail": "Chi tiết danh mục",
  "menu.dish-management.categories.category-dishes-management":
    "Món trong danh mục",
  "menu.dish-management.catalogues": "Bộ sưu tập món ăn",
  "menu.dish-management.catalogues.catalogue-list": "Danh sách bộ sưu tập",
  "menu.dish-management.catalogues.create-catalogue": "Tạo bộ sưu tập mới",
  "menu.dish-management.catalogues.catalogue-dishes-management":
    "Món trong bộ sưu tập",
  "menu.dish-management.catalogues.update-catalogue": "Cập nhật bộ sưu tập",
  "menu.dish-management.catalogues.catalogue-detail": "Chi tiết bộ sưu tập",
  "menu.dish-management.reviews": "Đánh giá món",
  "menu.dish-management.reviews.review-list": "Danh sách đánh giá",
  "menu.dish-management.reviews.create-review": "Tạo đánh giá",
  "menu.dish-management.reviews.update-review": "Cập nhật đánh giá",
  "menu.conversations": "Hội thoại AI",
  "menu.conversations.conversation-list": "Danh sách hội thoại",
  "menu.conversations.conversation-detail": "Chi tiết hội thoại",
  "menu.statistics": "Thống kê",
  "menu.statistics.overview": "Tổng quan",
  "menu.statistics.revenue": "Revenue",
  "menu.statistics.smart-scale-promotion": "Smart Scale Promotion",
  "menu.statistics.feature-satisfaction": "CSAT gợi ý",
  "menu.scale-management": "Quản lý đơn hàng",
  "menu.scale-management.orders": "Đơn hàng sản phẩm",
  "menu.scale-management.orders.order-list": "Danh sách đơn hàng",
  "menu.gift-management": "Quản lý quà tặng",
  "menu.gift-management.campaigns": "Chiến dịch quà tặng",
  "menu.gift-management.campaigns.campaign-list": "Danh sách chiến dịch",
  "menu.gift-management.orders": "Đơn hàng quà tặng",
  "menu.gift-management.orders.order-list": "Danh sách đơn hàng",
  "menu.gift-management.gift-codes": "Mã kích hoạt",
  "menu.tools": "Công cụ",
  "menu.tools.bmr-tdee-calculator": "Tính BMR & TDEE",
  "menu.ai-logging": "AI Logging",
  "menu.ai-logging.image-logs": "Quét ảnh thực phẩm",
  "menu.ai-logging.image-logs.image-logs-list": "Danh sách log quét ảnh",
  "menu.ai-logging.parsing-logs": "Phân tích giọng nói/văn bản",
  "menu.ai-logging.parsing-logs.parsing-logs-list": "Danh sách log phân tích",
  "menu.editor": "Trình soạn thảo đồ họa",
  "menu.editor.flow": "Trình soạn thảo luồng",
  "menu.editor.mind": "Trình soạn thảo tư duy",
  "menu.editor.koni": "Trình soạn thảo Koni",
  "menu.account.center": "Trang cá nhân",
  "menu.account.settings": "Cài đặt tài khoản",
  "menu.account.logout": "Đăng xuất",
  "menu.shop": "Quản lý Shop",
  "menu.shop.products": "Sản phẩm",
  "menu.shop.products.product-list": "Danh sách sản phẩm",
  "menu.shop.products.create-product": "Thêm sản phẩm",
  "menu.shop.products.update-product": "Chỉnh sửa sản phẩm",
  "menu.shop.orders": "Đơn hàng",
  "menu.shop.orders.order-list": "Danh sách đơn hàng",
  "menu.shop.shipping-methods": "Phương thức vận chuyển",
  "menu.shop.shipping-methods.shipping-method-list": "Danh sách phương thức",
  "menu.shop.payment-methods": "Phương thức thanh toán",
  "menu.shop.payment-methods.payment-method-list": "Danh sách phương thức",
  "menu.shop.settings": "Cài đặt Shop",
};
